'use client';

import useFilterStore from '@/publicSearch/store/useFilterStore';
import useSearchStore from '@/publicSearch/store/useSearchStore';
import { SearchType } from '@/hooks/publicSearch/useSearchType';
import {
  LogicalOperator,
  OperatorOption,
} from '@/components/publicSearch/constants';

/**
 * Quick-filter actions shared by the animal search grid cells and the mobile
 * animal card. `applyQuickFilter` replaces all filters with a single equals
 * filter; `upsertFilter` adds or replaces the equals filter for one field.
 */
export function useQuickFilterActions(searchType: SearchType) {
  const {
    clearFilter,
    setFilters,
    filters,
    addFilter,
    updateCommonFilterOperator,
  } = useFilterStore(searchType);
  const { setBasicSearch } = useSearchStore();

  const applyQuickFilter = (field: string, filterValue: string) => {
    clearFilter();
    setBasicSearch('');
    setFilters([
      { field, operator: OperatorOption.equals.value, value: filterValue },
    ]);
  };

  const upsertFilter = (field: string, filterValue: string) => {
    const next = {
      field,
      operator: OperatorOption.equals.value,
      value: filterValue,
    };
    const existingIndex = filters.findIndex((f) => f.field === field);
    if (existingIndex >= 0) {
      const newFilters = [...filters];
      newFilters[existingIndex] = next;
      setFilters(newFilters);
    } else {
      addFilter(next);
    }
    updateCommonFilterOperator(LogicalOperator.and);
  };

  return { applyQuickFilter, upsertFilter };
}
